// extracted by mini-css-extract-plugin
module.exports = {"root":"CardsContainer_root__2vTP9"};